import IntakeConfig from '../../interfaces/IntakeConfig.interface';

const planConfigUS: NonNullable<IntakeConfig['plan']>['countries'][string] = {
  label: 'Social AI',
  description: 'Content created weekly and automatically posted to your socials.\nIncludes posting to Facebook and Instagram.',
  periods: [
    {
      id: 'social-ai-local-monthly-usd',
      label: 'Monthly',
      price: 9900,
      unit: 'monthly',
      addons: [
        {
          id: 'platforms',
          label: 'Additional Platforms',
          type: 'multiselect',
          options: [
            {
              id: 'linkedin-*-usd',
              itemPriceId: 'linkedin-monthly-usd',
              label: 'LinkedIn',
              price: 2900,
              unit: 'monthly',
            },
          ],
        },
        {
          id: 'setupAssistance',
          label: 'Setup Assistance',
          description: 'Don\'t have a Facebook or Instagram account yet? Let us set them up for you.',
          type: 'multiselect',
          options: [
            {
              id: 'facebook-setup-usd',
              label: 'Basic Facebook Page Creation',
              price: 7500,
              unit: 'one-time',
            },
            {
              id: 'instagram-setup-usd',
              label: 'Basic Instagram Account Creation',
              price: 7500,
              unit: 'one-time',
            },
            {
              id: 'linkedin-setup-usd',
              label: 'Basic LinkedIn Page Creation',
              price: 7500,
              unit: 'one-time',
            },
          ],
        },
        {
          id: 'video',
          label: 'Short-Form Videos',
          description: '20-120 second short-form videos for Reels. 4 per month.',
          type: 'multiselect',
          options: [
            {
              id: 'short-form-video-*-usd',
              itemPriceId: 'short-form-video-monthly-usd',
              label: 'Short-Form Videos',
              price: 9900,
              unit: 'monthly',
            },
          ],
        },
      ],
    },
    {
      id: 'social-ai-local-annual-usd',
      label: 'Annual',
      price: 99000,
      unit: 'annually',
      addons: [
        {
          id: 'platforms',
          label: 'Additional Platforms',
          type: 'multiselect',
          options: [
            {
              id: 'linkedin-*-usd',
              itemPriceId: 'linkedin-annual-usd',
              label: 'LinkedIn',
              price: 29000,
              unit: 'annually',
            },
          ],
        },
        {
          id: 'setupAssistance',
          label: 'Setup Assistance',
          description: 'Don\'t have a Facebook or Instagram account yet? Let us set them up for you.',
          type: 'multiselect',
          options: [
            {
              id: 'facebook-setup-usd',
              label: 'Basic Facebook Page Creation',
              price: 7500,
              unit: 'one-time',
            },
            {
              id: 'instagram-setup-usd',
              label: 'Basic Instagram Account Creation',
              price: 7500,
              unit: 'one-time',
            },
            {
              id: 'linkedin-setup-usd',
              label: 'Basic LinkedIn Page Creation',
              price: 7500,
              unit: 'one-time',
            },
          ],
        },
        {
          id: 'video',
          label: 'Short-Form Videos',
          description: '20-120 second short-form videos for Reels.',
          type: 'multiselect',
          options: [
            {
              id: 'short-form-video-*-usd',
              label: '4 per month',
              itemPriceId: 'short-form-video-annual-usd',
              price: 99000,
              unit: 'annually',
            },
          ],
        },
      ],
    },
  ],
};

export default planConfigUS;
